import { GATEWAY_USER_SETTINGS_STORAGE_KEY } from './const/gatewayUserSettingsStorageKey.const'

export function clearGatewayUserSettings(): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.removeItem(GATEWAY_USER_SETTINGS_STORAGE_KEY)
  } catch {
    // localStorage unavailable (incognito, quota exceeded)
  }
}
